export default "__VITE_ASSET__DXrC3xxR__"